module.exports = __webpack_public_path__ + "img/location-map.60136c1f.jpg";